var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":_vm.persist,"max-width":_vm.maxWidth,"retain-focus":false},scopedSlots:_vm._u([{key:"activator",fn:function({ on}){return [_vm._t("button")]}}],null,true),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }